import axios from "axios";
import config from "@/utils/config";

const { apiHost, staticUrl } = config;

export async function callApi(endpoint, method, data, headers = {}) {
  const options = {
    url: `${apiHost}/api/v1${endpoint}`,
    method,
    headers
  };

  if (data) {
    options.headers["Content-Type"] = "application/json";
    options.data = data;
  }
  return new Promise((resolve, reject) => {
    axios(options)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export const fetchCohort = () => {
  return callApi(`/cohort`, "GET");
};

export const elnClassify = data => {
  return callApi(`/eln_classification`, "POST", data);
};

export const newClassify = data => {
  return callApi(`/quick_predict`, "POST", data);
};

export const predict = data => {
  return callApi(`/predict`, "POST", data);
};

export const warmApi = () => {
  const data = { gender: "male", plt: "10", add_5: 1 };
  callApi(`/quick_predict`, "POST", data).then(response => {
    console.log("quick_predict warming successful");
  });
  callApi(`/predict`, "POST", data).then(response => {
    console.log("predict warming successful");
  });
  callApi(`/eln_classification`, "POST", data).then(response => {
    console.log("eln_classification warming successful");
  });
};

export const fetchAverages = () => {
  const targetUrl = `${staticUrl}/data/average.json`;
  return fetch(targetUrl).then(response => response.json());
};
